<div class="drive">

  <!-- Toolbar — search on the left, filters and the grid/list switch on the right. -->
  <div class="drive-toolbar">
    <div class="drive-search">
      <mat-icon class="drive-search-icon">search</mat-icon>
      <input type="text" class="drive-search-input" placeholder="Search in attachments" aria-label="Search attachments"
        [value]="query()" (input)="onQuery($event)">
      @if (query()) {
      <button type="button" class="drive-search-clear" matTooltip="Clear search" (click)="clearQuery()">
        <mat-icon>close</mat-icon>
      </button>
      }
    </div>
  </div>
  <h6 class="drive-group-title">Roles</h6>
  <div class="drive-folders">
    @for (folder of folders(); track folder.title) {
    <button type="button" class="drive-folder" [class.selected]="isFolderOpen(folder.updatedByRole)"
      [attr.aria-pressed]="isFolderOpen(folder.updatedByRole)" (click)="openSectionFolder(folder.updatedByRole)">
      <mat-icon class="drive-folder-icon">{{ isFolderOpen(folder.updatedByRole) ? 'folder_open' : 'folder' }}</mat-icon>
      <span class="drive-folder-text">
        <span class="drive-folder-name" [matTooltip]="folder.title">{{ folder.title }}</span>
        <span class="drive-folder-sub">
          {{ folder.count }} {{ folder.count === 1 ? 'file' : 'files' }}
          <!-- @if (folder.sizeBytes) { • {{ formatSize(folder.sizeBytes) }} } -->
        </span>
      </span>
      <!-- @if (folder.pendingCount) {
              <span class="drive-folder-dot" [matTooltip]="folder.pendingCount + ' pending upload'"></span>
            } -->
    </button>
    }
  </div>

  @if (rows().length === 0) {

  <!-- Nothing attached anywhere yet. -->
  <div class="drive-empty">
    <mat-icon>folder_off</mat-icon>
    <p>No attachments yet</p>
    <span>
      Documents attached in the maintenance sections appear here, along with anything
      already on file for this adviser.
    </span>
  </div>

  } @else {

  <!-- Folders — one per maintenance section holding a document. Hidden inside a folder. -->

  @if (filteredToNothing()) {

  <div class="drive-empty">
    <mat-icon>search_off</mat-icon>
    <p>No attachments match your filters</p>
    <span>Try a different search term, or clear the filters to see everything again.</span>
    <button type="button" class="drive-empty-btn" (click)="clearFilters()">Clear filters</button>
  </div>

  } @else if (visibleRows().length) {

  <div class="drive-group-head">
    <h6 class="drive-group-title">Files</h6>
  </div>

  <!-- List: Drive's column header, sortable, with the same row affordances. -->
  <div class="drive-list">
    <div class="drive-list-head">
      <button type="button" class="drive-col name" (click)="sortBy('Category')">
        Category
        @if (sortKey() === 'Category') {
        <mat-icon>{{ sortDir() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        }
      </button>
      <button type="button" class="drive-col roles" (click)="sortBy('Roles')">
        Roles
        @if (sortKey() === 'Roles') {
        <mat-icon>{{ sortDir() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        }
      </button>
      <button type="button" class="drive-col section" (click)="sortBy('Name')">
        Name
        @if (sortKey() === 'Name') {
        <mat-icon>{{ sortDir() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        }
      </button>
      <button type="button" class="drive-col modified" (click)="sortBy('Last modified')">
        Last modified
        @if (sortKey() === 'Last modified') {
        <mat-icon>{{ sortDir() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        }
      </button>
      <span class="drive-col actions"></span>
    </div>

    @for (row of visibleRows(); track $index) {
    <div class="drive-list-row" [class.selected]="isSelected(row)" tabindex="0" role="button"
      [attr.aria-label]="row.documentLabel + ', ' + row.fileName" (click)="select(row)" (dblclick)="view(row)"
      (keydown.enter)="view(row)" (keydown.space)="select(row); $event.preventDefault()">

      <div class="drive-col name">
        <span class="drive-file-icon small" [class]="'kind-' + row.kind">
          <mat-icon>{{ fileIcon(row) }}</mat-icon>
        </span>
        <span class="drive-name-text">
          <span class="drive-row-name" [matTooltip]="row.documentLabel">{{ row.documentLabel}}</span>
          <!-- <span class="drive-row-label">{{ row.documentLabel }}</span> -->
        </span>
      </div>

      <div class="drive-col roles">
        <span class="drive-row-roles">{{ row.updatedByRole == 'NEWREP' ? 'APPLICANT' : row.updatedByRole }}</span>
      </div>

      <div class="drive-col section">
        <span class="drive-row-section" [matTooltip]="row.fileName">{{ row.fileName }}</span>
      </div>

      <div class="drive-col modified">
        @if (row.uploadedAt) {
        <span class="drive-row-date">{{ row.uploadedAt | date: 'dd/MM/yyyy' }}</span>
        } @else {
        <span class="drive-muted">—</span>
        }
      </div>

      <div class="drive-col actions">
        <button mat-icon-button matTooltip="Preview" aria-label="Preview" (click)="view(row); $event.stopPropagation()">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button matTooltip="download" aria-label="download" (click)="download(row); $event.stopPropagation()">
          <mat-icon>download</mat-icon>
        </button>
      </div>
    </div>
    }
  </div>

  } @else {

  <!-- Folders matched the search but this folder has no files left in it. -->
  <div class="drive-empty">
    <mat-icon>folder_open</mat-icon>
    <p>Nothing to show here</p>
    <span>No files match the current filters in this location.</span>
  </div>

  }
  }

  <!-- Document preview — same backdrop panel the new-rep application uses, so the
       page behind it keeps its scroll position while the preview is open. -->
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <div class="preview-header">
        <div class="preview-header-text">
          <span class="preview-title">Document Preview</span>
          <small class="preview-subtitle">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (previewMode === 'image') {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button title="Close" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="preview-content">
        @switch (previewMode) {
        @case ('pdf') {
        <iframe [src]="selectedDocument" class="preview-pdf" title="Document preview"></iframe>
        }
        @case ('image') {
        <img [src]="selectedDocument" alt="Document preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
        @case ('unsupported') {
        <div class="preview-message">
          <mat-icon>find_in_page</mat-icon>
          <p>No inline preview for this file type</p>
          <span>{{ currentFileName }} can be opened once downloaded.</span>
          @if (previewRow?.file) {
          <button type="button" class="preview-download-btn" (click)="download(previewRow!)">
            <mat-icon>download</mat-icon>
            Download
          </button>
          }
        </div>
        }
        @default {
        <div class="preview-message">
          <mat-icon>cloud_off</mat-icon>
          <p>Preview not available</p>
          <span>
            This document is held by the backend and no maintenance document endpoint is
            wired yet, so the file itself cannot be fetched.
          </span>
        </div>
        }
        }
      </div>

    </div>
  </div>
  }

</div>